import React from 'react';
import LiveTracking from '../../components/AdminNext/LiveTracking';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Live tracking — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <LiveTracking />
      </HeadLessLayout>
    )
  };
}

export default action;
